import { render } from "./process_documentation_managementFolderModeAndFileView.vue?vue&type=template&id=25dfa4ee&scoped=true"
import script from "./process_documentation_managementFolderModeAndFileView.vue?vue&type=script&lang=js"
export * from "./process_documentation_managementFolderModeAndFileView.vue?vue&type=script&lang=js"

import "./process_documentation_managementFolderModeAndFileView.vue?vue&type=style&index=0&id=25dfa4ee&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25dfa4ee"]])

export default __exports__